import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { TOWNS } from "./areaContent";

const chipCls = "inline-flex items-center gap-1.5 rounded-full border border-brand-blue/20 bg-white px-4 py-2 font-body text-sm font-medium text-brand-navy transition-colors hover:border-brand-blue";

const PINS = [
  { name: "Wallaceburg", x: 92, y: 70 },
  { name: "Dresden", x: 215, y: 60 },
  { name: "Tilbury", x: 70, y: 185 },
  { name: "Chatham", x: 190, y: 150, main: true },
  { name: "Blenheim", x: 270, y: 228 },
  { name: "Wheatley", x: 165, y: 248 },
  { name: "Ridgetown", x: 340, y: 160 },
];

export const ServiceArea = () => (
  <section id="service-area" data-testid="service-area-section" className="bg-brand-surface/50 py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <div>
        <p className="eyebrow">Service Area</p>
        <h2 className="h2 mt-5">Proudly serving Chatham-Kent</h2>
        <p className="lead mt-4 max-w-lg">On-site installs and friendly local support across the municipality — from downtown Chatham to the surrounding communities.</p>
        <ul className="mt-8 flex flex-wrap gap-2.5">
          <li data-testid="area-chip-0" className={chipCls}><MapPin className="h-3.5 w-3.5 text-brand-blue" strokeWidth={2} /> Chatham-Kent</li>
          {TOWNS.map((t) => (
            <li key={t.slug}>
              <Link to={`/areas/${t.slug}`} data-testid={`area-chip-${t.slug}`} className={`${chipCls} hover:text-brand-blue`}>
                <MapPin className="h-3.5 w-3.5 text-brand-blue" strokeWidth={2} /> {t.name}
              </Link>
            </li>
          ))}
          <li data-testid="area-chip-surrounding" className={chipCls}><MapPin className="h-3.5 w-3.5 text-brand-blue" strokeWidth={2} /> and surrounding areas</li>
        </ul>
        <Link to="/areas" data-testid="view-all-areas-link" className="link-arrow mt-7">
          View all service areas <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <MapIllustration />
    </div>
  </section>
);

const MapIllustration = () => (
  <div className="soft-card relative overflow-hidden p-4 sm:p-6" data-testid="service-area-map">
    <svg viewBox="0 0 420 300" className="h-auto w-full" role="img" aria-label="Illustrated map of Chatham-Kent communities">
      <defs>
        <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
          <path d="M20 0H0V20" fill="none" stroke="#E2E8F0" strokeWidth="1" />
        </pattern>
        <linearGradient id="land" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#E2E8F0" />
          <stop offset="1" stopColor="#E0F2FE" />
        </linearGradient>
      </defs>
      <rect width="420" height="300" fill="url(#grid)" />
      <path d="M40 40 L300 30 L395 120 L380 230 L250 285 L120 270 L30 180 Z" fill="url(#land)" stroke="#066AB2" strokeOpacity="0.35" strokeWidth="1.5" strokeDasharray="5 5" />
      <path d="M20 120 C 90 140, 150 120, 210 160 S 330 200, 410 190" stroke="#22D3EE" strokeOpacity="0.55" strokeWidth="3" fill="none" />
      {PINS.map((p) => (
        <g key={p.name} transform={`translate(${p.x} ${p.y})`}>
          {p.main && <circle r="26" fill="#22D3EE" opacity="0.18" />}
          <path d="M0 -22 C -9 -22 -14 -15 -14 -9 C -14 1 0 12 0 12 C 0 12 14 1 14 -9 C 14 -15 9 -22 0 -22 Z" fill={p.main ? "#066AB2" : "#0B2A44"} transform={p.main ? "scale(1.25)" : ""} />
          <circle cy={p.main ? -11 : -9} r="4" fill="#fff" />
          <text y="30" textAnchor="middle" className="font-heading" fontSize="12" fontWeight="600" fill="#0B2A44">{p.name}</text>
        </g>
      ))}
    </svg>
    <p className="absolute bottom-4 right-5 font-body text-[11px] font-medium uppercase tracking-[0.18em] text-brand-slate">Chatham-Kent, ON</p>
  </div>
);
